import React from "react";
import {TextArea, TextField} from "../../../Components/Inputs";
import {getFormatTextByValue, getOrderStatusTextByValue} from "../orderUtility";
import {Order} from "./orderManagement.types";

interface OrderEditFormViewProps {
    orderForDialog: Order;
    setOrderForDialog: (order: Order) => void;
}

export const OrderEditFormView = ({
    orderForDialog,
    setOrderForDialog
}: OrderEditFormViewProps) => {

    const handleNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setOrderForDialog({...orderForDialog, notes: event.target.value});
    };

    return <>
        <TextField
            label="Item Name"
            name="itemName"
            value={orderForDialog.itemName || ""}
            disabled={true}
        />
        <TextField
            label="Format"
            name="format"
            value={getFormatTextByValue(orderForDialog.format) || ""}
            disabled={true}
        />
        <TextField
            label="Order Status"
            name="orderStatus"
            value={getOrderStatusTextByValue(orderForDialog.orderStatus) || ""}
            disabled={true}
        />
        <TextField
            label="Student"
            name="studentName"
            value={orderForDialog.studentName || ""}
            disabled={true}
        />
        <TextArea
            label="Notes"
            name="notes"
            onChange={handleNotesChange}
            value={orderForDialog.notes || ""}
        />
    </>;
};
